const d3endpoints = {
    getMatchesByMatchId: '/matches/{matchId}',
    getPlayerSeasonStatisticsByCompetitionIdAndSeasonId: '/stats/players/competition/{competition_id}/season/{season_id}/order/{sortColumn}/{sortOrder}?page={page}&pageSize={pageSize}'
};

export default d3endpoints;